<template>
  <div :class="$style.icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        :class="$style[fillClass]"
        d="M6.70475 2.9195C6.9677 2.88107 7.23335 2.86195 7.49936 2.86231C9.88318 2.86231 12.1246 4.49931 13.4289 7.1514C13.2294 7.555 13.0041 7.94652 12.7543 8.32375C12.6749 8.44085 12.6332 8.57751 12.6343 8.71691C12.636 8.87292 12.6911 9.02412 12.7913 9.14745C12.8915 9.27078 13.0313 9.35946 13.1893 9.39996C13.3473 9.44046 13.5149 9.43056 13.6664 9.37177C13.8179 9.31297 13.9452 9.20852 14.0286 9.07434C14.3779 8.55102 14.6813 8.0011 14.9357 7.43019C14.9759 7.34099 14.9966 7.24492 14.9966 7.14782C14.9966 7.05073 14.9759 6.95466 14.9357 6.86546C13.4214 3.51283 10.5728 1.43262 7.49936 1.43262C7.14753 1.43093 6.79627 1.45964 6.44988 1.5184C6.35144 1.53436 6.25725 1.56865 6.17271 1.61932C6.08816 1.66999 6.01491 1.73604 5.95714 1.81371C5.89936 1.89137 5.85819 1.97913 5.83598 2.07196C5.81377 2.1648 5.81095 2.2609 5.82769 2.35477C5.84442 2.44865 5.88038 2.53846 5.93352 2.61908C5.98665 2.6997 6.05592 2.76956 6.13736 2.82465C6.2188 2.87975 6.31083 2.91901 6.40818 2.94019C6.50554 2.96137 6.60631 2.96405 6.70475 2.9481V2.9195ZM1.28493 0.210231C1.21504 0.143579 1.13206 0.0907085 1.04074 0.0546371C0.94942 0.0185657 0.851542 0 0.752697 0C0.653851 0 0.555973 0.0185657 0.464652 0.0546371C0.373331 0.0907085 0.290354 0.143579 0.22046 0.210231C0.0793017 0.344839 0 0.527407 0 0.717772C0 0.908137 0.0793017 1.09071 0.22046 1.22531L2.54431 3.43419C1.48401 4.40748 0.640145 5.57444 0.0630375 6.86546C0.0217604 6.95565 0.000454857 7.05299 0.000454857 7.1514C0.000454857 7.2498 0.0217604 7.34715 0.0630375 7.43734C1.57729 10.79 4.42588 12.8702 7.49936 12.8702C8.84652 12.8613 10.1619 12.4788 11.285 11.7693L13.7138 14.0926C13.7835 14.1596 13.8664 14.2127 13.9577 14.249C14.0491 14.2853 14.1471 14.304 14.246 14.304C14.345 14.304 14.443 14.2853 14.5343 14.249C14.6257 14.2127 14.7086 14.1596 14.7783 14.0926C14.8485 14.0261 14.9043 13.947 14.9423 13.8599C14.9804 13.7728 15 13.6794 15 13.585C15 13.4907 14.9804 13.3972 14.9423 13.3101C14.9043 13.223 14.8485 13.1439 14.7783 13.0775L1.28493 0.210231ZM6.05258 6.77968L7.88917 8.53105C7.76247 8.5657 7.63116 8.58256 7.49936 8.58109C7.10173 8.58109 6.72039 8.43046 6.43922 8.16234C6.15806 7.89422 6.0001 7.53058 6.0001 7.1514C5.99857 7.02572 6.01624 6.9005 6.05258 6.77968ZM7.49936 11.4405C5.11554 11.4405 2.87415 9.80348 1.57729 7.1514C2.06162 6.13185 2.74901 5.21172 3.60129 4.44213L4.92813 5.7217C4.61647 6.26413 4.49765 6.88829 4.58949 7.50057C4.68134 8.11284 4.97889 8.68022 5.43752 9.11757C5.89616 9.55492 6.49113 9.83867 7.1332 9.92625C7.77527 10.0138 8.4298 9.90052 8.99862 9.60332L10.1905 10.7256C9.37425 11.1838 8.44646 11.4302 7.49936 11.4405Z"
        fill="#9EA6AC"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
import iconsMixins from './../icons.mixins'

export default {
  name: 'EyeSlashIcon',

  mixins: [iconsMixins],

  data () {
    return {
      defaultStatusFill: {
        icon: 'grey-medium',
        bg: 'white'
      }
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';

.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}

@each $color, $value in $colors {
  .bg#{$color} {
    fill: $value;
  }
  .fill#{$color} {
    fill: $value;
  }
}
</style>
